// extracted by mini-css-extract-plugin
module.exports = {"container":"Pagination_container__AzYr_","pages":"Pagination_pages__RMfDk","item":"Pagination_item__71dSS","active":"Pagination_active__bCrgn"};